import styled, { createGlobalStyle } from 'styled-components';
import toggle from '../../assets/toggle.svg'

type BuilderContainerProps = {
	previewState: string
};

export const BuilderContainer = styled.div<BuilderContainerProps>`
	display: flex;
	width: ${(props) => props.previewState === 'collapsed' ? '100%' : 'calc(100% + 350px)'};
	height: 100vh;
	flex-flow: row nowrap;
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
	background-color: #fff;
	transform: ${(props) => props.previewState === 'collapsed' ? 'none' : 'translateX(-350px)'};
	transition: all 0.1s ease-in;
`;

export const FormContainer = styled.div`
	flex: 1;
	max-width: 690px;
	transition: all 0.2s ease-in;
`;

export const PreviewContainer = styled.div`
	position: relative;
	flex: 1;
`;

export const PreviewMenuContainer = styled.div`
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
	height: 100vh;
	background-color: #a0a0a01f;
`;

export const Form = styled.form`
	padding: 85px;
`;

export const FormTitle = styled.h1`
	margin-bottom: 50px;
	line-height: 1.15;
	font-weight: bold;
	font-size: 2.3rem;
	color: #1d1d1d;
`;

type ToggleButtonProps = {
	previewState: string
};

const ToggleButtonPseudoStyle = `
	content: "";
	width: 15px;
	height: 22px;
	margin-right: 5px;
	background: url(${toggle});
	background-size: 15px 20px;
	vertical-align: middle;
`;

export const ToggleButton = styled.button<ToggleButtonProps>`
	cursor: pointer;
	position: absolute;
	top: 20px;
	left: 40px;
	border: 0;
	font-weight: bold;
	color: #1d1d1d;
	text-transform: uppercase;
	text-decoration: none;
	background: transparent;
	&:before {
		display: ${(props) => props.previewState === 'collapsed' ? 'inline-block' : 'none'};
		${ToggleButtonPseudoStyle};
	}
	&:after {
		display: ${(props) => props.previewState === 'expanded' ? 'inline-block' : 'none'};
		${ToggleButtonPseudoStyle};
		transform: rotate(180deg) translateY(1px);
	}
`;

export const Preview = styled.div`
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
	padding: 0 20px;
	height: 100vh;
	background-color: #a0a0a01f;
`;

type ButtonProps = {
	primary?: boolean
}

export const Button = styled.button<ButtonProps>`
	width: auto;
	min-width: 200px;
	margin-top: 30px;
	padding: 14px 20px;
	font-weight: 500;
	font-size: 1rem;
	cursor: pointer;
	border-color: #000;
	border-radius: 3px;
	background-color: ${(props) => props.primary ? '#000' : '#fff'};
	color: ${(props) => props.primary ? '#fff' : '#000'};
	transition: opacity 0.2s ease-in;

	&:disabled {
		cursor: not-allowed;
		opacity: 0.5;
	}
`;

export const FormButtons = styled.div`
	display: flex;
	flex-flow: row nowrap;
	${Button} {
		&:nth-child(2) {
			margin-left: 10px;
		}
	}
`;

export const GlobalStyle = createGlobalStyle`
	.wrap {
		margin: 0;
	}
`;
